"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setMask = exports.getMask = void 0;
var _config = _interopRequireDefault(require("webmotors-react-pj/i18n/config"));
const getMask = (type, customMask) => ({
  default: undefined,
  date: '99/99/9999',
  'date-short': '99/9999',
  time: '99:99',
  plate: '',
  'new-plate': '',
  renavam: '99999999999',
  tel: _config.default.webinput.telMask,
  mobile: _config.default.webinput.mobileMask,
  zipcode: _config.default.webinput.zipcodeMask,
  document: _config.default.webinput.documentMask,
  documentCompany: _config.default.webinput.documentCompanyMask,
  custom: customMask
})[type || 'default'];
exports.getMask = getMask;
const setMask = _ref => {
  let {
    input,
    mask,
    initialValue,
    minSize = false,
    reverse = false,
    letters = false,
    after = null
  } = _ref;
  const event = () => {
    if (window.navigator.msPointerEnabled) {
      const eventInput = document.createEvent('Event');
      eventInput.initEvent('input', false, true);
      input.dispatchEvent(eventInput);
    } else {
      input.dispatchEvent(new Event('input'));
    }
  };
  const format = () => {
    let valueCount = 0;
    const valueArray = input.value.replace(/\D/g, '').split('');
    const valueFinal = [];
    const maskArray = mask.split('');
    if (reverse) {
      const maskArrayReverse = maskArray;
      const valueArrayReverse = valueArray;
      maskArrayReverse.reverse();
      valueArrayReverse.reverse();
      maskArrayReverse.forEach((item, i) => {
        if (valueArrayReverse[i - valueCount]) {
          if (/\D/.test(item)) {
            valueFinal.push(item);
            valueCount++;
          } else {
            valueFinal.push(valueArrayReverse[i - valueCount]);
          }
        }
      });
      valueFinal.reverse();
    } else {
      maskArray.forEach(item => {
        if (valueCount < valueArray.length) {
          if (/\D/.test(item)) {
            valueFinal.push(item);
          } else {
            valueFinal.push(valueArray[valueCount]);
            valueCount++;
          }
        }
      });
    }
    input.value = valueFinal.join('');
  };
  const init = () => {
    input.addEventListener('input', () => format());
    const _value = input.value.trim();
    if (_value !== '' || initialValue) {
      input.value = input.value || input.dataset.maskfyValue || initialValue;
    }
    event();
  };
  if (!input) {
    return console.error(new Error('Maskfy: Insert tag selector required. Ex.: Maskfy({tag: "[data-maskfy]"})'));
  }
  init();
};
exports.setMask = setMask;